/// <reference path="../setup/_references.ts" />
module onvio.clientDashboard {
    'use strict';

    angular.module('onvio.clientDashboard', [
        'onvio.clientDashboard.PreferenceService',
        'onvio.clientDashboard.ClientDashboardController',
        'onvio.clientDashboard.PhoneNumberListComponent',
        'onvio.clientDashboard.IdentityComponent',
        'onvio.clientDashboard.ClientAboutComponent',
        'onvio.clientDashboard.ClientCommentsComponent',
        'onvio.clientDashboard.ClientAssignmentsComponent',
        'onvio.clientDashboard.ClientAssignmentsItemComponent',
        'onvio.clientDashboard.ClientDashboardClientInformationService',
        'onvio.clientDashboard.ClientRelatedContactsComponent',
        'onvio.clientDashboard.ClientRelatedContactsItemComponent',
        'bm.core.dashboard.components.DashboardComponents',
        'bluemoon.accounting.components.ClientDashboard'
    ]);
}
